import React, { useState, useEffect } from "react";
import { collection, getDocs } from "firebase/firestore";
import { fetchRSSHeadlines } from "../../lib/rss";
import "./BottomTicker.css";

const RSS_REFRESH_MS = 10 * 60 * 1000; // 10 minutes

export default function BottomTicker({ db }) {
  const [rssHeadlines,    setRssHeadlines]    = useState([]);
  const [customHeadlines, setCustomHeadlines] = useState([]);
  const [rssLoaded,       setRssLoaded]       = useState(false);

  // Load custom admin breaking news from Firebase
  useEffect(() => {
    getDocs(collection(db, "breakingNews")).then((snap) => {
      setCustomHeadlines(snap.docs.map((d) => d.data().text).filter(Boolean));
    });
  }, [db]);

  // Fetch + auto-refresh RSS headlines every 10 minutes
  useEffect(() => {
    fetchRSSHeadlines()
      .then((h) => { setRssHeadlines(h); setRssLoaded(true); })
      .catch(() => setRssLoaded(true)); // still mark loaded even if RSS fails

    const interval = setInterval(
      () => fetchRSSHeadlines().then(setRssHeadlines).catch(() => {}),
      RSS_REFRESH_MS
    );
    return () => clearInterval(interval);
  }, []);

  // Custom breaking news ALWAYS comes first, RSS follows
  // Show the ticker as soon as custom headlines exist, even before RSS loads
  const hasContent = customHeadlines.length > 0 || (rssLoaded && rssHeadlines.length > 0);
  if (!hasContent) return null;

  // Build the combined list: custom first, RSS after
  const all   = [...customHeadlines, ...rssHeadlines];
  // Duplicate for seamless infinite loop
  const track = [...all, ...all];

  return (
    <div className="bottom-ticker">
      <div className="bottom-ticker-label">
        <span className="live-dot" />
        LIVE NEWS
      </div>
      <div className="bottom-ticker-overflow">
        <div className="bottom-ticker-track">
          {track.map((headline, i) => {
            // Identify custom headlines in both first and second copy of the array
            const isCustom =
              i < customHeadlines.length ||
              (i >= all.length && i - all.length < customHeadlines.length);
            return (
              <span key={i}>
                <span className={isCustom ? "custom-headline" : ""}>
                  {isCustom ? "⚡ " : ""}
                  {headline}
                </span>
                <span className="ticker-sep">◆</span>
              </span>
            );
          })}
        </div>
      </div>
    </div>
  );
}

